import { PolicyPayload } from 'Constants';
import samplePayload from 'utils/samplePayload';

let AppStorage;

const USE_SESSION_STORAGE = true;
const USE_HARDCODE_PAYLOAD = false;

if (!AppStorage) {
  AppStorage = {
    setItem: function(key, value) {
      if (!key) {
        return;
      }

      AppStorage[key] = value;
      console.log('AppStorage setItem key:', key, 'value:', value);

      if (USE_SESSION_STORAGE) {
        sessionStorage.setItem(key, JSON.stringify(value));
      }
      return;
    },

    getItem: function(key) {
      // Check the local AppStorage
      if (!key || !Object.prototype.hasOwnProperty.call(this, key)) {
        // Check the session storage
        if (USE_SESSION_STORAGE) {
          return JSON.parse(sessionStorage.getItem(key));
        }

        return null;
      }

      console.log('AppStorage getItem key:', key);

      return AppStorage[key];
    },

    clear: function() {
      if (sessionStorage) {
        sessionStorage.clear();
      }
    },

    removeItem: function(key) {
      if (!key || !Object.prototype.hasOwnProperty.call(this, key)) {
        if (USE_SESSION_STORAGE) {
          sessionStorage.removeItem(key);
        }
        return;
      }

      delete AppStorage[key];
      console.log('AppStorage removeItem:', key);
      return;
    },

    getPolicyPayload: function() {
      const policyPayload = this.getItem(PolicyPayload);
      return policyPayload ? policyPayload : null;
    },

    getInnerPayload: function() {
      const policyPayload = this.getPolicyPayload();
      return policyPayload ? policyPayload.payLoad : null;
    },

    getPolicySettingDto: function() {
      const innerPayload = this.getInnerPayload();
      if (innerPayload === null) {
        return null;
      }
      const { policySettingDto } = innerPayload;
      return policySettingDto ? policySettingDto : null;
    }

    // Uncomment to test promotion
    // PromotionPayload: {
    //   campaignName: 'nissan'
    // }
  };

  if (USE_HARDCODE_PAYLOAD) {
    AppStorage = {
      ...AppStorage,
      PolicyPayload: samplePayload
    };
  }
}

export default AppStorage;
